import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowRight } from 'lucide-react';
import api from '../services/api';

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const invoiceId = params.get('invoiceId');
  const [invoice, setInvoice] = useState(null);

  useEffect(() => {
    if (!invoiceId) return;
    // Vérifier le statut après 2s (laisser le webhook traiter)
    setTimeout(() => {
      api.get('/payments/status/' + invoiceId)
        .then(r => setInvoice(r.data))
        .catch(() => {});
    }, 2000);
  }, [invoiceId]);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--gray-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
      <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }}
        style={{ background: 'white', borderRadius: 20, padding: '3rem', textAlign: 'center', maxWidth: 480, width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.12)' }}>

        <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.2, type: 'spring' }}
          style={{ width: 80, height: 80, background: 'rgba(16,185,129,0.1)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem' }}>
          <CheckCircle size={40} color="#10B981" />
        </motion.div>

        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', color: 'var(--blue-dark)', letterSpacing: '1px', marginBottom: '0.8rem' }}>
          PAIEMENT RÉUSSI !
        </h1>
        <p style={{ color: 'var(--gray-text)', marginBottom: '2rem', lineHeight: 1.6 }}>
          Votre paiement a bien été reçu. Le mécanicien a été notifié automatiquement.
        </p>

        {invoice && (
          <div style={{ background: '#F8F9FB', borderRadius: 12, padding: '1rem', marginBottom: '2rem', textAlign: 'left' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
              <span style={{ color: 'var(--gray-text)', fontSize: '0.85rem' }}>Statut</span>
              <span style={{ color: '#10B981', fontWeight: 700, fontSize: '0.85rem' }}>✅ PAYÉE</span>
            </div>
          </div>
        )}

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to={'/facture/' + invoiceId}
            style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: 'var(--blue-dark)', color: 'white', padding: '0.8rem 1.5rem', borderRadius: 10, textDecoration: 'none', fontFamily: 'var(--font-cond)', fontWeight: 700 }}>
            Voir la facture
          </Link>
          <Link to="/dashboard"
            style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: 'linear-gradient(135deg,#FF6B00,#CC4400)', color: 'white', padding: '0.8rem 1.5rem', borderRadius: 10, textDecoration: 'none', fontFamily: 'var(--font-cond)', fontWeight: 700 }}>
            Mon espace <ArrowRight size={16} />
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
